import { render, staticRenderFns } from "./AssignVehiclesToGroup.vue?vue&type=template&id=156db9b9&scoped=true&"
import script from "./AssignVehiclesToGroup.vue?vue&type=script&lang=js&"
export * from "./AssignVehiclesToGroup.vue?vue&type=script&lang=js&"
import style0 from "./AssignVehiclesToGroup.vue?vue&type=style&index=0&id=156db9b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156db9b9",
  null
  
)

export default component.exports